import { PLACE_SHORT } from '../constants'
import { Stamp } from './Stamp'

/**
 * Signature / approval box on the sheet ground — not a navy agency CTA strip.
 * The stamp is the only inked element.
 */
export function ClosingBlock() {
  return (
    <section id="contact" className="bg-sheet">
      <div className="mx-auto max-w-[100rem] px-6 py-12 lg:px-8 lg:py-16">
        <div className="cell">
          <div className="grid lg:grid-cols-[1.2fr_auto]">
            <div className="border-b border-rule px-5 py-8 sm:px-8 lg:border-b-0 lg:border-r lg:py-10">
              <h2 className="section-title text-ink">
                Tell us what you need to ship
              </h2>
              <p className="mt-4 max-w-xl text-base leading-relaxed text-ink-muted">
                Share your context — product stage, timeline, and constraints. We
                answer with an honest assessment of the work, not a pitch deck.
              </p>
              <dl className="mt-8 grid gap-x-10 gap-y-4 sm:grid-cols-2">
                <div>
                  <dt className="cell-label text-ink-muted">Office</dt>
                  <dd className="mt-1.5 text-base font-medium text-ink">
                    {PLACE_SHORT}
                  </dd>
                </div>
                <div>
                  <dt className="cell-label text-ink-muted">Entity</dt>
                  <dd className="mt-1.5 text-base font-medium text-ink">
                    Passwork FZ LLC
                  </dd>
                </div>
              </dl>
            </div>

            <div className="flex flex-col items-start justify-center px-5 py-8 sm:px-8 lg:min-w-[20rem] lg:py-10">
              <Stamp size="lg" />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
